export default "__VITE_ASSET__DQUkmVa4__";